export const ViewOpenings = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            <h1 className="text-6xl font-semibold font-primary">Comming Soon</h1>
        </div>
    )
}